import { useCallback } from 'react';

import { useInviteMemberMutation } from '@/features/workspaces/api/workspacesApi';
import { getErrorMessage } from '@web/utils';
import { notify } from '@web/utils';

import type { InviteMemberPayload } from '@/features/workspaces/types';

export function useInviteMembers() {
  const [mutate, { isLoading }] = useInviteMemberMutation();

  const inviteAll = useCallback(
    async (items: InviteMemberPayload[]) => {
      if (!items.length) return { success: true } as any;
      let successCount = 0;
      for (const item of items) {
        try {
          const res = await mutate(item).unwrap();

          if (res.success) {
            successCount += 1;

            notify({ message: res.message || 'Invite sent', type: 'success' });
          } else {
            throw new Error(res.message || 'Failed to send invite');
          }
        } catch (error) {
          notify({
            message: getErrorMessage(error) || 'Failed to send invite',
            type: 'error',
          });

          return { success: false } as any;
        }
      }
      if (successCount === items.length) {
        notify({ message: 'Invites sent', type: 'success' });
        return { success: true } as any;
      }
      return { success: false } as any;
    },
    [mutate],
  );

  return { inviteAll, isLoading };
}
